import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createSlots as _createSlots, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/icons/sidebars/go-left.svg'


const _hoisted_1 = { class: "drop-area-hover" }
const _hoisted_2 = {
  key: 0,
  class: "bold"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  class: "c-media-header-bottom mt8"
}
const _hoisted_5 = { class: "mb16" }
const _hoisted_6 = { class: "c-media" }
const _hoisted_7 = { class: "c-list-image" }
const _hoisted_8 = {
  key: 0,
  class: "upload-card"
}
const _hoisted_9 = { class: "row-icon" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "col-12 mt5 p0 txt-center" }
const _hoisted_12 = { class: "font11" }
const _hoisted_13 = { class: "col-12 flex-center" }
const _hoisted_14 = { class: "col-12 flex-center mt10" }
const _hoisted_15 = { class: "font10" }
const _hoisted_16 = {
  class: "txt-detail",
  style: {"color":"var(--white)","text-decoration":"none"}
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 0,
  class: "col-12"
}
const _hoisted_20 = { class: "col-12 bold mb5 mt10" }
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = { class: "c-media" }
const _hoisted_23 = { class: "row c-modal-select-media" }
const _hoisted_24 = { class: "left" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "right" }
const _hoisted_28 = {
  key: 0,
  class: "row animate-bottom"
}
const _hoisted_29 = {
  key: 1,
  class: "row animate-bottom p5"
}
const _hoisted_30 = { class: "wrapper-folder" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "card-folder-logo" }
const _hoisted_33 = ["src"]
const _hoisted_34 = { class: "card-folder-title" }
const _hoisted_35 = {
  key: 2,
  class: "row"
}
const _hoisted_36 = { class: "directory-header" }
const _hoisted_37 = { class: "txt-secondary bold" }
const _hoisted_38 = { class: "row" }
const _hoisted_39 = {
  key: 0,
  class: "row"
}
const _hoisted_40 = { class: "directory-card" }
const _hoisted_41 = ["value", "type", "multiple"]
const _hoisted_42 = {
  key: 1,
  class: "row animate-bottom p5 is-loading"
}
const _hoisted_43 = {
  key: 2,
  class: "col-12 mt10"
}

export function render(_ctx, _cache) {
  const _component_c_button = _resolveComponent("c-button")
  const _component_c_img = _resolveComponent("c-img")
  const _component_media_from_computer = _resolveComponent("media-from-computer")
  const _component_c_empty = _resolveComponent("c-empty")
  const _component_c_loading = _resolveComponent("c-loading")
  const _component_c_modal = _resolveComponent("c-modal")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "content", {}, () => [
      (!_ctx.custom)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onDragenter: _cache[2] || (_cache[2] = _withModifiers((...args) => (_ctx.handleDragEnter && _ctx.handleDragEnter(...args)), ["prevent"])),
            onDragover: _cache[3] || (_cache[3] = _withModifiers((...args) => (_ctx.handleDragOver && _ctx.handleDragOver(...args)), ["prevent"])),
            onDragleave: _cache[4] || (_cache[4] = (...args) => (_ctx.handleDragLeave && _ctx.handleDragLeave(...args))),
            onDrop: _cache[5] || (_cache[5] = _withModifiers((...args) => (_ctx.handleDrop && _ctx.handleDrop(...args)), ["prevent"])),
            class: _normalizeClass([{ 'drag-active': _ctx.activeDrag }, "col-12 drop-area"]),
            tabindex: "0"
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("componentDragAndDropFile")), 1)
            ]),
            _createElementVNode("input", {
              type: "file",
              ref: "fileInput",
              class: "hidden",
              onChange: _cache[0] || (_cache[0] = (...args) => (_ctx.onChange && _ctx.onChange(...args)))
            }, null, 544),
            _createElementVNode("div", {
              class: _normalizeClass([{'mb16' : !_ctx.width}, "c-media-header"])
            }, [
              (_ctx.label)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t(_ctx.label)) + " ( " + _toDisplayString(_ctx.isThumbnail ? (_ctx.thumbnail ? 1 : 0) :
        Array.isArray(_ctx.newValue) ? (_ctx.newValue.length + (_ctx.files && _ctx.files.length)) :
        _ctx.newValue ? 1 : 0) + "/" + _toDisplayString(Array.isArray(_ctx.newValue) ? (_ctx.newValue.length +
        (_ctx.files && _ctx.files.length)) : _ctx.newValue ? 1 : 0) + " ) ", 1))
                : _createCommentVNode("", true),
              (_ctx.size)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t(_ctx.sizeLabel)) + ": " + _toDisplayString(_ctx.size), 1))
                : _createCommentVNode("", true)
            ], 2),
            (_ctx.width)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t(_ctx.widthLabel)) + ": " + _toDisplayString(_ctx.width), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: _normalizeClass([{'image-thumbnail-scroll' : _ctx.hasScroll, 'image-thumbnail': !_ctx.hasScroll}, "image-thumbnail-active"])
                }, [
                  (!_ctx.imageOnly)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("img", {
                            src: _ctx.uploadIcon,
                            alt: ""
                          }, null, 8, _hoisted_10)
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("componentDragAndDropFile")), 1)
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          (_ctx.readonly)
                            ? (_openBlock(), _createBlock(_component_c_button, {
                                key: 0,
                                isLoading: _ctx.isLoading,
                                class: "btn btn-browse-disabled",
                                value: "componentBrowse",
                                type: "span"
                              }, null, 8, ["isLoading"]))
                            : (_openBlock(), _createBlock(_component_c_button, {
                                key: 1,
                                onHandler: _ctx.onBrowseFile,
                                isLoading: _ctx.isLoading,
                                class: "btn btn-browse",
                                value: "componentBrowse",
                                type: "span"
                              }, null, 8, ["onHandler", "isLoading"]))
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.format), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.thumbnail)
                    ? (_openBlock(), _createBlock(_component_c_img, {
                        key: 1,
                        "onUpdate:src": _cache[1] || (_cache[1] = $event => (_ctx.thumbnail = '')),
                        src: _ctx.thumbnail,
                        isDelete: _ctx.isDelete,
                        readonly: _ctx.readonly,
                        class: "detail-img",
                        code: "key",
                        isThumbnail: _ctx.isThumbnail,
                        thumbnail: _ctx.thumbnail,
                        file: "",
                        uploaded: _ctx.uploadPercentage,
                        uploadedIndex: _ctx.uploadIndexIndex,
                        error: _ctx.uploadIndex
                      }, _createSlots({ _: 2 }, [
                        (_ctx.isThumbnail)
                          ? {
                              name: "img-action",
                              fn: _withCtx(({ row }) => [
                                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("productThumbnail")), 1)
                              ]),
                              key: "0"
                            }
                          : undefined
                      ]), 1032, ["src", "isDelete", "readonly", "isThumbnail", "thumbnail", "uploaded", "uploadedIndex", "error"]))
                    : _createCommentVNode("", true),
                  (_ctx.newValue && _ctx.newValue.length)
                    ? (_openBlock(), _createBlock(_component_c_img, {
                        key: 2,
                        "onUpdate:src": _ctx.onConfirmDelete,
                        src: _ctx.newValue,
                        isDelete: _ctx.isDelete,
                        readonly: _ctx.readonly,
                        class: "detail-img",
                        code: "key",
                        isThumbnail: _ctx.isThumbnail
                      }, _createSlots({ _: 2 }, [
                        (_ctx.isThumbnail && !_ctx.readonly)
                          ? {
                              name: "img-action",
                              fn: _withCtx(({ row }) => [
                                _createElementVNode("span", {
                                  onClick: $event => (_ctx.onOrderThumbnail(row)),
                                  class: "txt-detail",
                                  style: {"color":"var(--white)"}
                                }, _toDisplayString(_ctx.$t("productThumbnail")), 9, _hoisted_17)
                              ]),
                              key: "0"
                            }
                          : undefined
                      ]), 1032, ["onUpdate:src", "src", "isDelete", "readonly", "isThumbnail"]))
                    : (_ctx.readonly && _ctx.newValue && _ctx.newValue.length > 0)
                      ? (_openBlock(), _createBlock(_component_c_img, {
                          key: 3,
                          src: '',
                          isDelete: false,
                          readonly: _ctx.readonly,
                          class: "detail-img",
                          code: "key",
                          isThumbnail: _ctx.isThumbnail
                        }, null, 8, ["readonly", "isThumbnail"]))
                      : (_ctx.readonly && !_ctx.thumbnail)
                        ? (_openBlock(), _createBlock(_component_c_img, {
                            key: 4,
                            src: '',
                            isDelete: false,
                            readonly: _ctx.readonly,
                            class: "detail-img",
                            code: "key",
                            isThumbnail: _ctx.isThumbnail
                          }, null, 8, ["readonly", "isThumbnail"]))
                        : _createCommentVNode("", true),
                  (_ctx.files && _ctx.files.length)
                    ? (_openBlock(), _createBlock(_component_c_img, {
                        key: 5,
                        "onUpdate:src": _ctx.removeDraftFile,
                        src: _ctx.files,
                        isDelete: _ctx.isDelete,
                        readonly: _ctx.readonly,
                        class: "detail-img",
                        code: "key",
                        isThumbnail: _ctx.isThumbnail,
                        file: "",
                        uploaded: _ctx.uploadPercentage,
                        uploadedIndex: _ctx.uploadIndexIndex,
                        error: _ctx.uploadIndex
                      }, _createSlots({ _: 2 }, [
                        (_ctx.isThumbnail && !_ctx.readonly)
                          ? {
                              name: "img-action",
                              fn: _withCtx(({ row }) => [
                                _createElementVNode("span", {
                                  onClick: $event => (_ctx.onOrderThumbnailFile(row, _ctx.thumbnail)),
                                  class: "txt-detail",
                                  style: {"color":"var(--white)"}
                                }, _toDisplayString(_ctx.$t("productThumbnail")), 9, _hoisted_18)
                              ]),
                              key: "0"
                            }
                          : undefined
                      ]), 1032, ["onUpdate:src", "src", "isDelete", "readonly", "isThumbnail", "uploaded", "uploadedIndex", "error"]))
                    : _createCommentVNode("", true)
                ], 2)
              ]),
              (_ctx.invalidFiles && _ctx.invalidFiles.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, _toDisplayString(!_ctx.uploadError ? _ctx.$t("componentInvalidFileType") : _ctx.$t("componentInvalidUpload")) + " : ", 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invalidFiles, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item,
                        class: "col-12 invalid-file"
                      }, [
                        _createElementVNode("span", {
                          innerHTML: item?.value,
                          class: "txt-detail"
                        }, null, 8, _hoisted_21)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 34))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createVNode(_component_c_modal, {
        onOnClose: _ctx.onCloseBrowseFile,
        onOnConfirm: _ctx.onUpdateValue,
        labelText: "componentSelectMedia",
        active: _ctx.isModal,
        modalSize: "modal-lg",
        isText: "",
        isOverlay: ""
      }, {
        modal: _withCtx(({ row }) => [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabFolders, (tab) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: tab,
                    class: "col-12"
                  }, [
                    _createElementVNode("div", {
                      onClick: $event => (_ctx.onTabChange(tab?.code)),
                      class: _normalizeClass([{'active': _ctx.activeFolder === tab?.code}, "nav-link"])
                    }, _toDisplayString(_ctx.$t(tab?.value)), 11, _hoisted_26)
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              (_ctx.activeFolder === 'C001' && !_ctx.isDirectory?.code)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createVNode(_component_media_from_computer, {
                      isArray: _ctx.isArr,
                      onSelectedMedia: _ctx.onSelectMediaOnly
                    }, null, 8, ["isArray", "onSelectedMedia"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.activeFolder === 'S001' && !_ctx.isDirectory?.code)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.folders, (folder) => {
                        return (_openBlock(), _createElementBlock("div", {
                          onClick: $event => (_ctx.goDirectory(folder)),
                          key: folder,
                          class: "card-folder"
                        }, [
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("img", {
                              src: require('@/assets/icons/sidebars/folder.svg'),
                              alt: ""
                            }, null, 8, _hoisted_33)
                          ]),
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("span", null, _toDisplayString(folder?.title || "N/A"), 1)
                          ])
                        ], 8, _hoisted_31))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isDirectory?.code)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("span", null, [
                        _createElementVNode("img", {
                          src: _imports_0,
                          class: "bg-primary w25 h25 radius10 pointer mr10",
                          onClick: _cache[6] || (_cache[6] = (...args) => (_ctx.goBackDirectory && _ctx.goBackDirectory(...args)))
                        }),
                        _createElementVNode("span", null, [
                          _createTextVNode(_toDisplayString(_ctx.isDirectory?.title) + " ", 1),
                          _createElementVNode("strong", _hoisted_37, "(" + _toDisplayString(_ctx.form.code && _ctx.isArr ? _ctx.form.code.length :
                    (_ctx.form.code.length ? [_ctx.form.code].length : 0)) + ")", 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", {
                      onScroll: _cache[9] || (_cache[9] = (...args) => (_ctx.handleScroll && _ctx.handleScroll(...args))),
                      ref: "listMediaBody",
                      class: "directory-list"
                    }, [
                      _createElementVNode("div", _hoisted_38, [
                        (_ctx.directoriesImage.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.directoriesImage, (direct) => {
                                return (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.form.code) = $event)),
                                    value: direct.key,
                                    onChange: _cache[8] || (_cache[8] = (...args) => (_ctx.onChangeSelected && _ctx.onChangeSelected(...args))),
                                    type: _ctx.isArr ? 'checkbox' : 'radio',
                                    multiple: _ctx.isArr,
                                    class: "input-checkbox"
                                  }, null, 40, _hoisted_41), [
                                    [_vModelDynamic, _ctx.form.code]
                                  ]),
                                  _createVNode(_component_c_img, {
                                    isOnLoading: _ctx.isDirectoryLoading,
                                    src: _ctx.$helper?.getFullImage(direct?.key),
                                    class: "detail-img"
                                  }, null, 8, ["isOnLoading", "src"])
                                ]))
                              }), 256))
                            ]))
                          : (!_ctx.isDirectoryLoading && !_ctx.directoriesImage.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                _createVNode(_component_c_empty)
                              ]))
                            : _createCommentVNode("", true),
                        (_ctx.isDirectoryLoading)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                              _createVNode(_component_c_loading, { loading: true })
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ], 544)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      }, 8, ["onOnClose", "onOnConfirm", "active"])
    ])
  ], 64))
}